<script>
    import { getContext } from 'svelte'
    import Typography from './Typography.svelte'
    import { ChevronBackOutline } from '../Icons'
    import { slide } from 'svelte/transition'
    export let label = ''
    export let expanded = false
    export let size = null
    size = size ? size : getContext('size') || 'medium'
    const current = getContext('current')
    const { index = null } = getContext('setIndex') || {}
    const id = index ? index() : null
    function onClick() {
        if (current) {
            $current.current = id
        } else {
            expanded = !expanded
        }
    }
    $: if (current) {
        expanded = $current.current === id
    }
</script>

<div class="container">
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="header" on:click={onClick}>
        {#if $$slots.header}
            <slot name="header" />
        {:else}
            <Typography
                type={size === 'medium' ? 'h4' : 'h5'}
                style={`font-weight: 500;color: var(--color-${expanded ? 'accent-01' : 'grey-400'}); margin: 0; padding: 0`}
                >{label}</Typography
            >
        {/if}
        <ChevronBackOutline
            size={25}
            style={`transform: rotateZ(${expanded ? '-90' : '-180'}deg)`}
        />
    </div>
    {#if expanded}
        <div
            class="content"
            class:medium={size === 'medium'}
            class:small={size === 'small'}
            transition:slide|local
        >
            <slot />
        </div>
    {/if}
</div>

<style>
    div {
        width: 100%;
    }
    /* .container {
    } */
    .content {
        position: relative;
        padding: 15px;
        height: max-content;
        border-bottom: 0.5px var(--color-grey-400) solid;
    }
    .header {
        padding: 3px 15px;
        border-bottom: 1px var(--color-grey-400) solid;
        min-height: 60px;
        height: fit-content;
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        user-select: none;
        cursor: pointer;
        background: rgba(0, 0, 0, 0);
    }

    .header:hover {
        background: rgba(255, 0, 0, 0.01);
    }

    .header :global(svg) {
        transition: transform 0.2s ease-in-out;
    }

    .medium {
        line-height: 21px;
        font-size: 17px;
        font-weight: 400;
    }
    .small {
        line-height: 17px;
        font-size: 14px;
        font-weight: 400;
    }

    /* .content :global() {
    } */

    /* .content :global(li::before) {
        content: "•";
        color: var(--color-brand-primary-01);
        margin-right: 15px;
        display: inline-block;
    } */

    .content :global(ul) {
        margin: 10px 0 0 0;
        display: flex;
        position: relative;
        flex-direction: column;
        gap: 13px;
        /* font-size: 17px; */
        /* list-style: none; */
        /* list-style-type: symbols(\9773); */
    }

    /* .ingroup {
        border: 0;
    } */
</style>
